import { Sparkles, Recycle, ShieldCheck, Gem } from "lucide-react";

const values = [
  {
    icon: Sparkles,
    title: "Curated elegance",
    description: "Add pieces from any boutique or brand. From high-end fashion to sustainable homeware, your wishlist becomes a polished expression of your taste.",
    iconBg: "bg-[hsl(45,90%,50%)]/20",
    iconColor: "text-[hsl(45,90%,50%)]",
  },
  {
    icon: Recycle,
    title: "Purpose over clutter",
    description: "Every wanted gift stays in rotation and out of landfill. Hintsly helps ensure every present has a home, a purpose, and a person who loves it.",
    iconBg: "bg-destructive/15",
    iconColor: "text-destructive",
  },
  {
    icon: ShieldCheck,
    title: "Graceful coordination",
    description: "Claims and sharing keep everyone aligned, so there are no duplicate purchases, awkward guesses, or wasted budgets behind the scenes.",
    iconBg: "bg-foreground/10",
    iconColor: "text-foreground",
  },
  {
    icon: Gem,
    title: "Premium gifting energy",
    description: "Hintsly turns gifting into a considered experience with elegant prompts, refined presentation, and a little Spark when timing matters.",
    iconBg: "bg-[hsl(45,90%,50%)]/20",
    iconColor: "text-[hsl(45,90%,50%)]",
  },
];

const ValuePropsGrid = () => {
  return (
    <section className="px-4 py-20 bg-background/70">
      <div className="container max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-foreground mb-4">
          Why Hintsly feels different
        </h2>
        <p className="text-center text-muted-foreground mb-12 max-w-2xl mx-auto">
          A sharper, more considered way to help the right people get gifting exactly right.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((v) => (
            <div
              key={v.title}
              className="premium-panel rounded-[1.75rem] p-6"
            >
              <div className={`mb-4 flex h-12 w-12 items-center justify-center rounded-xl ${v.iconBg}`}>
                <v.icon className={`h-6 w-6 ${v.iconColor}`} />
              </div>
              <h3 className="mb-2 font-bold text-foreground">{v.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{v.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuePropsGrid;
